import { render, staticRenderFns } from "./project-pop.vue?vue&type=template&id=52f0c368&"
import script from "./project-pop.vue?vue&type=script&lang=js&"
export * from "./project-pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "project-pop.vue"
export default component.exports